/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerCreateMutationRequest, ProjectsControllerCreateMutationResponse, ProjectsControllerCreate400, ProjectsControllerCreate401, ProjectsControllerCreate403 } from "../../models/projectsController/ProjectsControllerCreate";

function getProjectsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/projects` as const }  
  return res
}

/**
 * @summary Create a new project under a parent scope
 * {@link /api/v1/projects}
 */
export async function projectsControllerCreate(data?: ProjectsControllerCreateMutationRequest, config: Partial<RequestConfig<ProjectsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerCreateMutationResponse, ResponseErrorConfig<ProjectsControllerCreate400 | ProjectsControllerCreate401 | ProjectsControllerCreate403>, ProjectsControllerCreateMutationRequest>({ method : "POST", url : getProjectsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}